export class HayppFeatureNames {
  static Kevel: string = 'kevel';
}
